import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import {
  SalesOrderStatus,
  SalesOrderSyncStatus,
} from 'src/types/application/SalesOrderDTOV2_DEPRECATED';
import { invalidateTaskCounts } from '@/pages/authenticated/home/utils/invalidateTaskCounts';

const useApproveSalesOrderDraft = (
  salesOrderDraftId: string,
  onSuccess?: (params: {
    salesOrderId: string;
    status: SalesOrderStatus;
    originSyncStatus: SalesOrderSyncStatus | null;
  }) => void,
  onError?: (error: Error) => void,
) => {
  const queryClient = useQueryClient();

  return useMutationApi<
    void,
    {
      salesOrderId: string;
      status: SalesOrderStatus;
      originSyncStatus: SalesOrderSyncStatus | null;
    }
  >({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/approve`,
    method: 'POST',
    successMessage: 'Sales order draft approved successfully',
    options: {
      onSuccess: (data) => {
        // Invalidate home page task counts
        invalidateTaskCounts(queryClient);
        // Call consumer's onSuccess callback
        onSuccess?.(data.data);
      },
      onError: onError
        ? (error) => {
            onError(error as Error);
          }
        : undefined,
    },
  });
};

export default useApproveSalesOrderDraft;
